// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Waiting_wrapper__3N3Ld","loader":"Waiting_loader__1t2zi","userName":"Waiting_userName__3m12C"};